export class AdvancedSearch {
  constructor(public data: any) { }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/model/advanced-search.model.ts